import PropTypes from "prop-types";
import * as React from "react";
import QuickActionTile from "../templates/quickActionTile";
import {
    SSE_ADVANTAGE_IRE,
    SSE_ADVANTAGE_UK,
} from "../../../constants/externalUrls";
import useUserProfile from "../../../services/apiUtils/hooks/useUserProfile";
import { jwtDecode } from "jwt-decode";
import SingleLinkTile from "../templates/singleLinkTile";
import { quickActionTilesMap } from "../tilesMap";

const AdvantageTile = ({ id }) => {
    const { userProfileToken } = useUserProfile();

    const decodedToken = userProfileToken && jwtDecode(userProfileToken);
    const countrySpecificLink =
        decodedToken?.BUSINESS_GROUP === "SSE Ireland"
            ? SSE_ADVANTAGE_IRE
            : SSE_ADVANTAGE_UK;
    const alternativeText =
        decodedToken?.PERSON_TYPE === "CWK"
            ? "Advantage is not available to contractors"
            : null;

    return (
        <QuickActionTile id={id}>
            <SingleLinkTile
                link={countrySpecificLink}
                linkText={quickActionTilesMap[id].description}
                title={"SSE Advantage"}
                alternativeText={alternativeText}
            />
        </QuickActionTile>
    );
};

AdvantageTile.propTypes = {
    id: PropTypes.string.isRequired,
};

export default AdvantageTile;
